/**
 * Returns date in range (min, max) included.
 *
 * @param {moment.Moment|null} date
 * @param {moment.Moment|null} min
 * @param {moment.Moment|null} max
 * @return {moment.Moment|null}
 */
import moment from 'moment';
import dateIsValid from './dateIsValid';

const getDateInAllowedRange = (date, min, max) => {
  if (dateIsValid(date)) {
    let result = date;

    if (min) {
      result = moment.max(result, min);
    }

    if (max) {
      result = moment.min(result, max);
    }

    return result;
  }

  return null;
};

export default getDateInAllowedRange;
